import React, {useEffect, useState} from 'react'
import { Dropdown, Grid, Segment, Input, Button, Icon } from 'semantic-ui-react'
import {useForm, Controller} from "react-hook-form"
import WebsitesData from "../Sections/WebsitesData"
import './style.css'

const Websites = () => {
    const {
        register,
        control,
        handleSubmit,
        reset
    } = useForm()

    const [projects, setProject] = useState([])
    const [language, setLanguage] = useState([])
    const [responsible, setresponsible] = useState([])
    const [responseMessage, setResponseMessage] = useState('');

    async function adProject(){
        const response = await fetch('https://crm.axcap.ae/rest/1/y9x9q1wmj1mwq5bu/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438');
        const data = await response.json();
        setProject(data.result[0].LIST)
    }
    async function adLang(){
        const response = await fetch('https://crm.axcap.ae/rest/1/y9x9q1wmj1mwq5bu/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131');
        const data = await response.json();
        setLanguage(data.result[0].LIST)
    }
    
    async function adResponsible(){
        const response = await fetch('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv');
        const data = await response.json();
        setresponsible(data)
    }

    useEffect(() => {
        adProject();
        adLang();
        adResponsible();
    }, [])


    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))
    const transformLanguage = language.map(language => ({
        key: language.ID,
        text: language.VALUE,
        value: language.ID
    }))
    
    const transformResponsible = responsible.map(responsible => ({
        key: responsible.ID,
        text: responsible.NAME,
        value: responsible.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const onSubmit = async (fields) => {

            try {
                const response = await fetch("https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe", {
                    method: 'POST',
                    mode: 'cors', 
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    redirect: 'follow',
                    referrerPolicy: 'no-referrer',
                    body: JSON.stringify({fields, "source": "website"}) 
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
        
                const data = await response.json(); // Получаем тело ответа в формате JSON
                setResponseMessage(data); 

                reset();
            } catch (error) {
                console.error('Error:', error);
                setResponseMessage('An error occurred'); // Сообщение в случае ошибки
            }
        
    }

    
    return(
        <>
            <h1 className='title'>-- Landings --</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container columns='equal' className='grid-form'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Campaign Code
                                </span>
                                <Controller
                                    name='code'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input type='text' placeholder='Insert...' {...field}/>}
                                />
                                
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Responsible
                                </span>
                                <Controller
                                    name='responsible'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='select responsible'
                                            fluid
                                            search
                                            selection
                                            options={transformResponsible}
                                            value={value}
                                            // defaultValue="1"
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Project
                                </span>
                                <Controller
                                    name='Ad_Project'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Project'
                                            fluid
                                            search
                                            selection
                                            options={transformProject}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Language
                                </span>
                                <Controller
                                    name='Ad_Language'
                                    control={control}
                                    render={({ field: { onChange, value, ...field } }) => (
                                        <Dropdown
                                            placeholder='Select Language'
                                            fluid
                                            search
                                            selection
                                            options={transformLanguage}
                                            value={value}
                                            onChange={(e, data) => onChange(data.value)}
                                            {...field}
                                        />
                                    )} 
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className='item'>
                                <span>
                                    Source Details
                                </span>
                                <Controller
                                    name='source_detail'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                        <div className='item'>
                                <span>
                                    Marker:
                                </span>
                                <Controller
                                    name='marker'
                                    defaultValue=""
                                    control={control}
                                    render={({field}) => <Input placeholder='Insert...' {...field}/>}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Button animated className='fb-button'>
                        <Button.Content visible>Create Integration</Button.Content>
                        <Button.Content hidden>
                            <Icon name='arrow right' />
                        </Button.Content>
                    </Button>
                </Grid>
            </form>
            {responseMessage && (
                <div className='reponse-message'>
                    <p>Response: {responseMessage.message} | ID: {responseMessage.id}</p>
                </div>
            )}
            <WebsitesData projectsProps={projects}/>
        </>
    )
}

export default Websites;
